// Keys that belong to an IME composition, not to the screen.
//
// Promise:
// - The Enter that confirms a conversion and the Escape that cancels one are
//   never taken as "send", "save" or "close": every Enter / Escape handler
//   asks this first (one way in, so no handler checks only half of it).
// - Safari sends that Enter as keyCode 229 without `isComposing`; either one
//   counts. Pass a React event's `nativeEvent` (or the DOM event itself).

/** Whether a key event is part of an IME composition. */
export function isImeComposing(e: {
  isComposing?: boolean;
  keyCode?: number;
}): boolean {
  return e.isComposing === true || e.keyCode === 229;
}
